// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Edit as RawEdit } from "lucide-react";
export const Edit = /* @__PURE__ */ createIcon(RawEdit, "Edit", 2);
